// extracted by mini-css-extract-plugin
export default {"brandSource":"BrandSource2_brandSource__dkn-w","brandSourceIcon":"BrandSource2_brandSourceIcon__eNFOy","brandSourceName":"BrandSource2_brandSourceName__LYnP0"};